module.exports = __webpack_public_path__ + "img/alert-info.9e3160f5.svg";